import { createFileRoute } from '@tanstack/react-router'

import { type Product, productSchema } from '@orus.eu/product'

import { NotFound } from '../../../../../components/organisms/not-found.tsx'
import { CertificateInfoPage } from '../../../../../components/pages/certificate/certificate-info-page.tsx'
import { certificateSearchSchema } from '../../certificate-search-schema.ts'

export const Route = createFileRoute('/s/a/$token/$product')({
  validateSearch: certificateSearchSchema,
  component: function RouteComponent() {
    const { token, product } = Route.useParams()
    const { lg } = Route.useSearch()

    if (productSchema.allows(product)) {
      return <CertificateInfoPage product={product as Product} token={token} language={lg} />
    }

    return <NotFound />
  },
})
